export const SCHEME_TYPE = {
    DETAIL: 'detail'
};

export const PLATFORM_TYPE = {
    NIUNIU: 'niuniu',
    MOOMOO: 'moomoo'
};

export const PROTOCOL_TYPE = {
    NN: 'ftnn',
    MOOMOO: 'ftmm'
};

export function useJump(props) {
    const { useBehaviour } = require('@fegobull/webapi').use;
    const { runBehaviour } = useBehaviour();

    const platform = props.platform || PLATFORM_TYPE.MOOMOO;

    const protocol = platform === PLATFORM_TYPE.NIUNIU ? PROTOCOL_TYPE.NN : PROTOCOL_TYPE.MOOMOO;

    const type = platform === PLATFORM_TYPE.NIUNIU ? 'jump' : 'jumpMM';

    const jumpToStock = (stockId, $event) => {
        console.log('jumpToStock stockId', stockId);
        const link = `${protocol}://quote/stockDetail/${stockId}/1`;
        link && runBehaviour(null, { type, value: link }, $event);
    };

    const jumpToAskAi = (stockId) => {
        const link = `${protocol}://ai?tab=1&isHex=1`;
        runBehaviour(null, { type, value: link });
    };

    const jumpToStockRatingDetail = (stockId) => {
        // 评级变动
        const link = `${protocol}://stockDetail/analystDetail?selectedType=analyst&selectedCard=filterList&stockId=${stockId}`;
        runBehaviour(null, { type, value: link });
    };

    const jumpToStockAnalystDetail = (stockId, analystId) => {
        // 个股评级分析师
        const link = `${protocol}://stockDetail/analystStockRating?stockId=${stockId}&analystId=${analystId}`;
        runBehaviour(null, { type, value: link });
    };

    const jumpToAnalystDetail = (analystId) => {
        // Schema: futumm://stockDetail/analystRatingSummary?analystId=${analystId}
        const link = `${protocol}://stockDetail/analystRatingSummary?analystId=${analystId}`;
        runBehaviour(null, { type, value: link });
    };

    const jumpToChipDistribution = (stockId) => {
        // futumm://stockDetail/chipDistribution?stockId=
        const link = `${protocol}://stockDetail/chipDistribution?stockId=${stockId}`;
        runBehaviour(null, { type, value: link });
    };

    return {
        jumpToStock,
        jumpToAskAi,
        jumpToStockAnalystDetail,
        jumpToAnalystDetail,
        jumpToStockRatingDetail,
        jumpToChipDistribution
    };
}
